import { z } from "zod";

export const activateSubscriptionSchema = z.object({
	group_id: z.string().uuid(),
});

export type ActivateSubscriptionPayload = z.infer<typeof activateSubscriptionSchema>;
